module.exports = __webpack_public_path__ + "static/media/prick_HMPG_header_image_01_1400.4d126ca6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_header_image_01_1400.jpg
// module id = 344
// module chunks = 0